import React, { useState } from "react";
import ComplexText from "@ui/complex-text";
import WidgetContainer from "@widgets/render-engine/widget-container";
import PickWidget from "@widgets/render-engine/pick-widget";
import { IconArrowRight, IconArrowDown } from "@ui/icons";

const CoreCompositeWidget = ({ data }) => {
    return (
        <>
            {data.items.map((item, index) => {
                return (
                    <WidgetContainer key={index} data={item.data}>
                        <PickWidget widget={item} />
                    </WidgetContainer>
                );
            })}
        </>
    );
};

const Collapsible = ({ data }) => {
    const [isOpen, setOpen] = useState(data.isOpen ?? false);

    const handleClick = (e) => {
        e.preventDefault();
        setOpen(!isOpen);
    };
    const showIcon = data.showIcon;
    const hideCollapsibleInLargeScreen = data.hideCollapsibleInLargeScreen;
    return (
        <>
        <div className={hideCollapsibleInLargeScreen ? "mobile md:hidden" : ""}>
            <div
                className="flex items-center justify-between cursor-pointer"
                onClick={handleClick}
            >
                {data.text && (
                    <h2 className="text-skin-dark cursor-pointer">
                        {data.text && <ComplexText values={data.text} />}
                    </h2>
                )}
                <a
                    href="#"
                    className="flex items-center gap-1 text-skin-primary"
                >
                    {isOpen ? data.linkTextOpen : data.linkTextClose}{" "}
                    {isOpen && showIcon && (
                        <IconArrowDown className="w-5 h-5" />
                    )}
                    {!isOpen && showIcon && (
                        <IconArrowRight className="w-5 h-5" />
                    )}
                </a>
            </div>
            {isOpen && (
                <div>
                    <CoreCompositeWidget data={data} />
                </div>
            )}
        </div>
        {hideCollapsibleInLargeScreen &&
        (<div className="desktop hidden md:flex">
                <div>
                    <CoreCompositeWidget data={data} />
                </div>
        </div>)}
          
        </>
    );
};

export default Collapsible;
